import {Directive, forwardRef, Input} from '@angular/core';
import {FormControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';
import {StringUtils} from '../services/utils/stringUtils';

@Directive({
    providers: [{
            multi: true,
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => MinMaxValidatorDirective),
        }],
    selector: '[lvMinMaxValidator]',
    standalone: false
})
export class MinMaxValidatorDirective implements Validator {

  @Input('minValue')
  public min: number;

  @Input('maxValue')
  public max: number;

  @Input('validationNeeded')
  public validationNeeded: boolean = true;

  @Input()
  public errorMessage: string;

  @Input()
  public isDouble: boolean;

  @Input()
  public nachkommastellen: number = 2;

  private _REGEX_GANZE_ZAHL = /^[1-9]{1}[0-9]*$/;

  public validate(control: FormControl): ValidationErrors | null {
    if (!this.validationNeeded) {
      return null;
    }
    if (!control || (!control.value && control.value !== 0) || control.value.length === 0) {
      return null;
    }
    return this._checkNumber(control);
  }

  private _checkNumber(control: FormControl): ValidationErrors | null {
    const numberToValidate = control.value.toString().trim().replace(',', '.');
    if (!this.isDouble) {
      if (!numberToValidate.match(this._REGEX_GANZE_ZAHL) && numberToValidate !== '0') {
        return {ERROR: 'WRONG_NUMBER'};
      }
    } else {
      if (!numberToValidate.length || numberToValidate.charAt(0) === '.') {
        return {ERROR: 'WRONG_DOUBLE_NUMBER'};
      }
      if (numberToValidate.charAt(numberToValidate.length - 1) === '.') {
        return {PARTIAL: 'MISSING_DECIMAL_NUMBERS'};
      }
      for (let i = 0; i < numberToValidate.length; i++) {
        if (numberToValidate.charAt(i) === ' ' || // Blanks sind bei isNaN false, daher extra prüfung
            numberToValidate.charAt(i) !== '.' && isNaN(numberToValidate.charAt(i))) {
          return {ERROR: 'WRONG_DOUBLE_NUMBER'};
        }
      }
      if (numberToValidate.indexOf('.') > 0) {
        const eingegebeneNachkommastellen = numberToValidate.substring(numberToValidate.indexOf('.') + 1);
        if (eingegebeneNachkommastellen.length > this.nachkommastellen) {
          return {PARTIAL: 'TOO_MANY_DIGITS', VIOLATION: this.nachkommastellen};
        }
      }
    }
    if (StringUtils.isNotNull(this.min) && +numberToValidate < this.min) {
      return !!this.errorMessage ? {PARTIAL: this.errorMessage} :
          {PARTIAL: 'TOO_SMALL', VIOLATION: +this.min};
    }
    if (StringUtils.isNotNull(this.max) && +numberToValidate > this.max) {
      return !!this.errorMessage ? {PARTIAL: this.errorMessage} :
          {PARTIAL: 'TOO_BIG', VIOLATION: +this.max};
    }
    return null;
  }
}
